import { FormPageReq } from "./FormPageReq"

export class FormSaveReq {
    id?: string
    name: string = ""
    description: string = ""

    pages: FormPageReq[] = []
    validations: FormValidationReq[] = []
}

export class FormValidationReq {
    id?: string
    validationName: string = ""
    ruleType: string = ""
    rulesValue: string = ""
}

export interface FormFieldUploadImageResp {
  attachmentUrl: string;
}